import React, { useEffect } from 'react';
import { LogoKappaBlack } from 'Images';
import { useSessionStorage } from '../../Hooks/useStorage';
import style from './style';
import useTranslation from '../../Hooks/useTranslation';

const { notFoundContainer, imageStyle, errorCode, pageNotFoundMessage, errorMessage } = style;

export default function index() {
  const { t } = useTranslation();
  const [token] = useSessionStorage('token', '');
  return (
    <div style={notFoundContainer}>
      <img src={LogoKappaBlack} style={imageStyle} alt="icono" />
      <h1 style={errorCode}>404</h1>
      <h2 style={pageNotFoundMessage}>{t('NotFound.PageNotFound')}</h2>
      <h2 style={errorMessage}>{t('NotFound.Message')}</h2>
    </div>
  );
}
